<div mat-dialog-title>
  <h1 class="titulo-simpli">Eliminar Cuenta</h1>
  <small class="subtitulo-simpli">Confirmar acción</small>
</div>
<div mat-dialog-content>¿Estas seguro que deseas eliminar la cuenta?</div>
<div mat-dialog-actions>

  <button mat-stroked-button class="secondary-button" (click)="dialogRef.close('N')">No</button>

  <button class="primary-button" mat-stroked-button  (click)="delete_add()" [disabled]="disabled">
    <mat-label *ngIf="!showSpinner">Si</mat-label>
    <span *ngIf="showSpinner"><i style="color:gray;" class="fa-solid fa-circle-notch fa-spin-pulse"></i></span>
  </button>
  
</div>